import axios from 'axios';
export default function (dataUrl) {
  const url = process.env.VUE_APP_SERVER_API_UOA+'upload-firebase';

  return axios.post(url, {uri:dataUrl});
};